import * as ng from 'angular';
import { StSearch } from './st-search.directive';

export const StSearchModule: string =
    ng.module('st-search', [
    ])
        .directive('stSearch', StSearch)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-search/st-search.module.ts